export default "__VITE_ASSET__ZhXXL9$7__"